module.exports = __webpack_public_path__ + "front/img/m_top.dd220e3f.png";